import { useTranslation } from "react-i18next";
import React, { useEffect } from 'react'
import { Button, DatePicker, Flex, Form, Modal, Select } from 'antd'
import type { RangePickerProps } from 'antd/es/date-picker'

type Props = {
  title: string
  open: boolean
  handleClose: () => void
  handleOk?: () => void
  exportExcel: (value: any) => void
  filterData?: any
  setFilterData?: (dateString: string[], planCreationDate: string) => void
}

const ExportAccountModal: React.FC<Props> = ({
  title,
  open,
  handleClose,
  handleOk,
  exportExcel,
  setFilterData
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm()
  const { RangePicker } = DatePicker

  const options = [
    { value: 1, label: t("Khóa", "Khóa") },
    { value: 2, label: t("Mở khóa", "Mở khóa") }
  ]

  useEffect(() => {
    // Khi modal mở lại, reset form để tránh giữ giá trị cũ
    if (open) {
      form.resetFields()
    }
  }, [open, form])

  const onRangeChange: RangePickerProps['onChange'] = (_value, dateString) => {
    // Nếu parent muốn cập nhật filter ngay khi chọn ngày
    if (setFilterData) setFilterData(dateString as string[], 'approvedDate')
  }

  const onFinish = (values: any) => {
    // Chuẩn hóa approvedDate thành array string YYYY-MM-DD nếu là moment
    const payload = { ...values }
    if (payload.approvedDate && Array.isArray(payload.approvedDate)) {
      payload.approvedDate = payload.approvedDate.map((d: any) =>
        d && typeof d.format === 'function' ? d.format('YYYY-MM-DD') : d
      )
    }

    // Gọi export với payload đã chuẩn hoá
    exportExcel(payload)

    // Gọi callback success / đóng modal
    if (handleOk) handleOk()
    handleClose()
  }

  return (
    <Modal
      title={title}
      open={open}
      centered
      onCancel={handleClose}
      destroyOnClose
      footer={null}
    >
      <Form
        form={form}
        name="form-export-account"
        layout="vertical"
        onFinish={onFinish}
      >
        <Form.Item name="status" label={t("Trạng thái", "Trạng thái")}>
          <Select placeholder={t("Chọn trạng thái", "Chọn trạng thái")} options={options} />
        </Form.Item>

        <Form.Item name="approvedDate" label={t("Ngày tạo", "Ngày tạo")} className="w-full">
          <RangePicker
            placeholder={[t("Từ ngày", "Từ ngày"), t("Đến ngày", "Đến ngày")]}
            format="YYYY-MM-DD"
            className="w-full"
            onChange={onRangeChange}
          />
        </Form.Item>

        <div style={{ textAlign: 'center', marginTop: 8 }}>
          <Flex justify="end" gap="16px">
            <Button onClick={handleClose}>{t("Hủy", "Hủy")}</Button>
            <Button
              className="btn-primary"
              onClick={() => {
                // submit form; không đóng modal trước khi submit
                form.submit()
              }}
            >
              {t("Kết xuất", "Kết xuất")}
            </Button>
          </Flex>
        </div>
      </Form>
    </Modal>
  )
}

export default ExportAccountModal
